module.exports = __webpack_public_path__ + "img/sun-snowflake-variant.434658f4.svg";